import { render, staticRenderFns } from "./BackOrderList.vue?vue&type=template&id=57079499&lang=pug&"
import script from "./BackOrderList.vue?vue&type=script&lang=js&"
export * from "./BackOrderList.vue?vue&type=script&lang=js&"
import style0 from "./BackOrderList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports